import React from 'react';
import AuthPage from '../pages/AuthPage';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import VerifyEmail from '../pages/VerifyEmail';

/** Purpose: Renders unauthenticated auth flows. Inputs: auth state + setters. Output: auth page element. */
export default function AuthFlowContainer({
  verifyToken,
  onClearVerifyToken,
  authView,
  onSetAuthView,
  resetToken,
  onClearResetToken,
  onLogin
}) {
  if (verifyToken) {
    return (
      <VerifyEmail
        token={verifyToken}
        onSuccess={() => {
          onClearVerifyToken();
          onSetAuthView('login');
        }}
      />
    );
  }

  if (authView === 'forgot') {
    return <ForgotPassword onBack={() => onSetAuthView('login')} />;
  }

  if (authView === 'reset' && resetToken) {
    return (
      <ResetPassword
        token={resetToken}
        onBack={() => {
          onSetAuthView('login');
          onClearResetToken();
        }}
        onSuccess={() => {
          onSetAuthView('login');
          onClearResetToken();
        }}
      />
    );
  }

  return (
    <AuthPage
      onLogin={onLogin}
      onForgotPassword={() => onSetAuthView('forgot')}
    />
  );
}
